import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';

import { KontrollterminPreviewComponent } from './kontrolltermin-preview.component';
import { EditKontrollterminDialogModule } from './edit-kontrolltermin-dialog/edit-kontrolltermin-dialog.module';

@NgModule({
  declarations: [
    KontrollterminPreviewComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatSnackBarModule,
    MatButtonModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatDialogModule,
    EditKontrollterminDialogModule
  ],
  exports: [
    KontrollterminPreviewComponent
  ]
})
export class KontrollterminPreviewModule { }
